import { Component } from '@angular/core';
import { Router, NavigationEnd} from '@angular/router';
import { ContextService } from '../services';
@Component({
  selector: 'layout-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {
	context_root: string;
  today: number = Date.now();
  area: string;
   constructor(
     private router: Router, 
    private contextService: ContextService
  ) {}

  ngOnInit() {
  		this.context_root=(this.contextService.getContext()=='B2B')?'':'/familles';

       this.router.events.subscribe((ev:any) => {
         if (ev instanceof NavigationEnd ) {
          let url =ev.url.split("/");
          this.area = (url[1] && url[1]=='familles') ? 'B2C':'B2B';
          this.contextService.setContext(this.area);
          this.context_root=(this.contextService.getContext()=='B2B')?'':'/familles';
        }
          
     });
  	 }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/footer.component.ts